/* eslint-disable @typescript-eslint/dot-notation */
import OlDrawInteraction from "ol/interaction/Draw";
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import * as events from "ol/events";
import * as sphere from "ol/sphere";
import ensureFeatureId from "@mapsight/lib-ol/feature/ensureId";
import { formatArea } from "../../helpers/formatArea";
import { formatLength } from "../../helpers/formatLength";
const defaultOptions = {
    type: "Point",
};
// FIXME: We monkey path some methods marked as private, that are not really private
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default class DrawInteraction extends OlDrawInteraction {
    _source = null;
    _replacePrevious = false;
    _clearOnStart = false;
    _measure = false;
    _sketchFeature = null;
    _sketchPoint = null;
    _sketchLine = null;
    _measureCoordinate = null;
    _measureChangeListener = null;
    constructor(options) {
        super({ ...defaultOptions, ...options });
        this.on("drawstart", this.handleSketchStart.bind(this));
        this.on("drawend", this.handleSketchEnd.bind(this));
    }
    abort() {
        // only need to abort if active
        if (this.getActive()) {
            // abort by quickly de- and then reactivating ol interaction
            this.setActive(false);
            this.setActive(true);
        }
    }
    /** @override */
    updateSketchFeatures_(...args) {
        super["updateSketchFeatures_"].apply(this, args);
        this._sketchPoint = this["sketchPoint_"];
        this._sketchLine = this["sketchLine_"];
    }
    /** @override */
    createOrUpdateSketchPoint_(...args) {
        super["createOrUpdateSketchPoint_"].apply(this, args);
        this._sketchPoint = this["sketchPoint_"];
    }
    handleSketchStart(startEvent) {
        // set sketch
        this._sketchFeature = startEvent.feature;
        if (this._clearOnStart) {
            this._source?.clear();
        }
    }
    handleSketchEnd({ feature }) {
        // unset sketch
        this._sketchFeature = null;
        // save feature?
        if (this._source) {
            feature.set("measurementType", undefined);
            ensureFeatureId(feature);
            if (this._replacePrevious) {
                this._source.clear();
            }
            this._source.addFeature(feature);
        }
    }
    initMeasurement() {
        this._measureChangeListener = null;
        this._measureCoordinate = null;
        this.addEventListener("drawstart", (event) => {
            // TODO: Check that the event actually gives a coordinate!!!
            console.log("TODO: Check that the event actually gives a coordinate!!!");
            this.handleMeasurementStart(event);
        });
        this.addEventListener("drawend", this.handleMeasurementEnd.bind(this));
    }
    updateMeasurementFeatures(label = "") {
        if (this._sketchFeature) {
            this._sketchFeature.set("measurementType", "drawFeature");
            this._sketchFeature.set("measurementLabel", label);
        }
        if (this._sketchPoint) {
            this._sketchPoint.set("measurementType", "drawPoint");
            this._sketchPoint.set("measurementLabel", label);
        }
        if (this._sketchLine) {
            this._sketchLine.set("measurementType", "drawLine");
            this._sketchLine.set("measurementLabel", label);
        }
    }
    handleMeasurementStart({ coordinate }) {
        this._measureCoordinate = coordinate;
        const sketchGeometry = this._sketchFeature?.getGeometry();
        if (sketchGeometry) {
            this._measureChangeListener = sketchGeometry.on("change", this.handleMeasurementChange.bind(this));
        }
        this.updateMeasurementFeatures();
    }
    handleMeasurementChange({ target: geometry }) {
        let output;
        if (geometry instanceof Polygon) {
            output = formatArea(sphere.getArea(geometry));
            this._measureCoordinate = geometry
                .getInteriorPoint()
                .getCoordinates();
        }
        else if (geometry instanceof LineString) {
            output = formatLength(sphere.getLength(geometry));
            this._measureCoordinate = geometry.getLastCoordinate();
        }
        this.updateMeasurementFeatures(output);
    }
    handleMeasurementEnd() {
        if (this._measureChangeListener) {
            events.unlistenByKey(this._measureChangeListener);
        }
    }
    /** @override */
    setMap(map) {
        super.setMap(map);
        this.initMeasurement();
    }
    getSource() {
        return this._source;
    }
    setSource(source) {
        this._source = source;
    }
    setMeasure(measure) {
        this._measure = measure;
    }
    getMeasure() {
        return this._measure;
    }
    setReplacePrevious(replacePrevious) {
        this._replacePrevious = replacePrevious;
    }
    getReplacePrevious() {
        return this._replacePrevious;
    }
    setClearOnStart(clearOnStart) {
        this._clearOnStart = clearOnStart;
    }
    getClearOnStart() {
        return this._clearOnStart;
    }
    getStyle() {
        return this["overlay_"].getStyle();
    }
    setStyle(styleFunction) {
        this["overlay_"].setStyle(styleFunction);
    }
}
